// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"010c7487","977":"86190d2f"}[chunkId] + ".chunk.js";
};